<template>
  <div>
    <common-dialog ref="dialog" width="1200px" :show-save-button="false" title="明细进度" id-key="ProductionProgressId" @close-saved="$emit('close-saved')">
      <el-table ref="list" border :data="tableData" style="width: 100%">
        <el-table-column prop="WorkDocNo" label="加工单号"></el-table-column>
        <el-table-column prop="ProductNo" label="存货编码"></el-table-column>
        <el-table-column prop="ProductName" label="存货名称"></el-table-column>
        <el-table-column prop="UnitName" label="主单位"></el-table-column>
        <el-table-column prop="ColorName" label="颜色"></el-table-column>
        <el-table-column prop="PropertyName" label="属性"></el-table-column>
        <el-table-column prop="Quantity" label="生产数量"></el-table-column>
        <el-table-column prop="StockInQuantity" label="累计入库数量"></el-table-column>
        <el-table-column prop="UnQuantity" label="未入库数量"></el-table-column>
      </el-table>

      <template slot="footer">
        <el-button type="primary" @click="enter">确定</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  data() {
    return {
      api: require('@/api/pr/prProductionProgress').default,
      api2: require('@/api/production/workDoc').default,
      // data: {
      //   ProductionProgressId: 0,
      //   OrderId: 0,
      //   OrderProductId: 0,
      //   Progress: "",
      //   ProgressStr: "",
      //   InRate: 0,
      //   InQuantity: 0,
      //   Remarks: "",
      //   ProductNo: "",
      //   ProductName: "",
      //   ProductSpec: "",
      //   OrderNo: "",
      //   OrderDate: "",
      //   OrderProductNo: "",
      // },
      isShow4: false,
      isShow5: false,
      isShow6: false,
      isShow7: false,
      isShow8: false,
      isShow9: false,
      tableData: [],
      safetyStock: false,
      minStock: false,
      saleOrderConsumption: false,
      tempData: []
    }
  },
  methods: {
    setData(obj) {
      this.api2.getWdpProgress(obj).then(res => {
        if (res.Code === 0) {
          let data = res.Data
          data.forEach(item => {
            if (item.Stage == 0) {
              item.ProductNo = item.MouldNo
              item.ProductName = item.MouldName
            }
          })

          this.tableData = data
        }
      })
    },
    enter() {
      this.close()
    }
  }
}
</script>
